import React from "react";
import "../styles/Offer.css";

const Offer = () => {
  return (
    <section>
      <div className="bullet-section">
        <h2 className="second-title">What we Offer</h2>

        <div className="points-container">
          <div className="grid-item left no-line">
            <p className="points">
              <strong>Simplified Learning</strong> <br />
              Lessons tailored to your pace, helping you build confidence, road
              awareness, steering, and speed control.
            </p>
          </div>
          <div className="grid-item empty"></div>

          <div className="grid-item empty"></div>

          <div className="grid-item right">
            <p className="points">
              <strong>Flexible Hours</strong> <br />
              Lessons available on evenings and weekends to suit your schedule.
            </p>
          </div>

          <div className="grid-item left">
            <p className="points">
              <strong>Convenient Pick-up & Drop-off</strong>
              <br />
              Seamlessly fit lessons into your routine.
            </p>
          </div>
          <div className="grid-item empty"></div>

          <div className="grid-item empty"></div>
          <div className="grid-item right">
            <p className="points">
              <strong>Stress-Free Experience</strong> <br />
              Patient, supportive tuition designed to help you learn with
              confidence.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offer;
